/**
 * Stacking for journal write overlays that portal to document.body.
 * The slash phrase menu must sit above both the editor fullscreen
 * (`JournalRichTextEditor`) and the old-note reader (`JournalWriteReadingPanel`).
 */
export const JOURNAL_EDITOR_FULLSCREEN_Z = 90;
export const JOURNAL_READ_FULLSCREEN_Z = 90;
export const JOURNAL_PHRASE_POPOVER_Z = 100;
export const JOURNAL_PHRASE_MODAL_Z = 110;

export const JOURNAL_EDITOR_FULLSCREEN_Z_CLASS = 'z-[90]';
export const JOURNAL_PHRASE_POPOVER_Z_CLASS = 'z-[100]';
export const JOURNAL_PHRASE_MODAL_Z_CLASS = 'z-[110]';
